import { Container, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setMessage } from '../toasts/toastSlice';
import { setOrdersModalConfig } from './orderSlice';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPES } from '../../config/consts/commons';
import { QRScanner } from '../common/components/QRScanner';

function QRScannerViewer({ onClose }) {
  const { t } = useTranslation(['system', 'description', 'title']);
  const { orderQR } = useSelector((state) => state.orders);

  const dispatch = useDispatch();
  const handleResult = async (data, scanner) => {
    const scanLink = new URL(data);
    const id_order = scanLink.searchParams.get('data');

    if (Number(orderQR?.id_order) === Number(id_order)) {
      dispatch(
        setMessage({
          body: t('SUCCESS_ORDER_CONFIRM', {
            ns: 'system',
            order: orderQR?.id_order,
          }),
          type: NOTIFICATION_TYPES.SUCCESS,
        })
      );
      dispatch(
        setOrdersModalConfig({
          titleOpening: t('orders.deliver.modal.wish_deliver_order', {
            ns: 'description',
          }),
          show: true,
          order: { ...orderQR },
          modalType: 'toDeliver',
        })
      );

      onClose();
    } else {
      dispatch(
        setMessage({
          body: t('QR_ERROR_VALIDATION_ORDER', { ns: 'system' }),
          type: NOTIFICATION_TYPES.ERROR,
        })
      );
    }

    onClose();
    try {
      if (scanner && typeof scanner.stop === 'function') {
        await scanner.stop();
      }
      if (scanner && typeof scanner.destroy === 'function') {
        scanner.destroy();
      }
    } catch {}
  };

  return (
    <Container maxWidth="sm">
      <Typography
        component="h1"
        variant="h4"
        mt={4}
        mb={2}
        sx={{ fontWeight: 'bold' }}
      >
        {t('qr_code', { ns: 'title' })}
      </Typography>

      <Typography component="p" variant="body1" mb={4}>
        {t('qr_code_label', { ns: 'description' })}
      </Typography>

      <QRScanner handleResult={handleResult} />
    </Container>
  );
}

export default QRScannerViewer;
